













































































import { Component } from 'vue-mixin-decorator';
import BaseView from '@/views/BaseView.vue';
import ExamFooter from '@/components/ExamFooter.vue';
import ExamGuide from '@/components/ExamGuide.vue';
import ExamNav from '@/components/ExamNav.vue';
import BirthdaySelect from '@/components/BirthdaySelect.vue';
import IndicatorModal from '@/components/IndicatorModal.vue';

import * as Message from '@/common/Messages';
import * as StringUtil from '@/common/StringUtil';

import { PASSWORD_LENGTH_MIN, PASSWORD_LENGTH_MAX } from '@/classification/KenteiDefinition';

import RepositoryFactory from '@/repository/RepositoryFactory';

import PasswordResetSettingParam from '@/models/account/PasswordResetSettingParam';

@Component(
  {
    components: {
      'e-footer': ExamFooter,
      'e-guide': ExamGuide,
      'e-nav': ExamNav,
      'birthday-select': BirthdaySelect,
      'e-indicator': IndicatorModal,
    },
  },
)
export default class PassForgetSetting extends BaseView {
  private passwordInfo = new PasswordResetSettingParam();

  private errMsg = {
    newPassword: '',
    newPasswordConfirmation: '',
    birthday: '',
  };

  private isFailedReset = false;

  private resetFailMessage ='';

  private isIndicatorDisplay = false;

  private mounted() {
    const CommonCss = document.createElement('link');
    CommonCss.rel = 'stylesheet';
    CommonCss.href = '/css/common.css';
    this.$el.appendChild(CommonCss);

    const AccountCommonCss = document.createElement('link');
    AccountCommonCss.rel = 'stylesheet';
    AccountCommonCss.href = '/account/css/common.css';
    this.$el.appendChild(AccountCommonCss);

    this.getExamConfigCss().then((cssElement: HTMLLinkElement) => {
      this.$el.appendChild(cssElement);
    });

    const CommonJs = document.createElement('script');
    CommonJs.src = '/js/common.js';
    this.$el.appendChild(CommonJs);
  }

  /**
   * パスワードリセット処理
   */
  async resetPassword() {
    if (this.validate()) {
      return;
    }

    try {
      this.isIndicatorDisplay = true;

      const { token } = this.$route.query;
      this.passwordInfo.token = String(token);

      const AccountRepository = RepositoryFactory.get().account;
      await AccountRepository.resetPassword(this.passwordInfo).then((response) => {
        if (response.status === 204) {
          this.$router.replace(this.paths.PASS_FORGET_COMPLETE);
        } else {
          this.isFailedReset = true;
          this.resetFailMessage = Message.RESET_PASSWORD_FAILURE;
        }
      })
        .catch((err) => {
          this.isFailedReset = true;
          if (err.response.status === 400) {
            // 生年月日やトークンが無効
            this.resetFailMessage = Message.INVALID_TOKEN_OR_BIRTHDAY;
          } else {
            this.resetFailMessage = Message.RESET_PASSWORD_FAILURE;
          }
        });
    } catch (e) {
      this.isFailedReset = true;
      this.resetFailMessage = Message.RESET_PASSWORD_FAILURE;
    } finally {
      this.isIndicatorDisplay = false;
    }
  }

  /**
   * 入力項目の検証
   *  一つでもエラーが存在する場合TRUEを返却
   */
  private validate() {
    this.errMsg.newPassword = '';
    this.errMsg.newPasswordConfirmation = '';
    this.errMsg.birthday = '';

    this.validatePassword();
    this.validatePasswordConfirm();
    this.validateBirthday();

    return Object.values(this.errMsg).some((val) => !StringUtil.isEmpty(val));
  }

  /**
   * パスワードのValidateを行います。
   */
  private validatePassword() {
    if (StringUtil.isEmpty(this.passwordInfo.newPassword)) {
      this.errMsg.newPassword = Message.REQUIRED_PASSWORD;
      return;
    }
    const password = String(this.passwordInfo.newPassword);

    if (password.length < PASSWORD_LENGTH_MIN || password.length > PASSWORD_LENGTH_MAX) {
      this.errMsg.newPassword = Message.PASSWORD_LENGTH;
      return;
    }

    const isIncludeUppercase = password.match('[A-Z]') !== null;
    const isIncludeLowercase = password.match('[a-z]') !== null;
    const isIncludeNumericOrSymbol = password.match('[0-9]|[!"#$%&\'()*+,-./:;<=>?@[\\]^_`{|}~]') !== null;
    if (!isIncludeUppercase || !isIncludeLowercase || !isIncludeNumericOrSymbol) {
      this.errMsg.newPassword = Message.PASSWORD_STRING_TYPE;
    }
  }

  /**
   * パスワード（確認）のValidateを行います。
   */
  private validatePasswordConfirm() {
    if (StringUtil.isEmpty(this.passwordInfo.newPasswordConfirmation)) {
      this.errMsg.newPasswordConfirmation = Message.REQUIRED_PASSWORD_CONFIRM;
      return;
    }

    if (String(this.passwordInfo.newPassword) !== String(this.passwordInfo.newPasswordConfirmation)) {
      this.errMsg.newPasswordConfirmation = Message.NEW_PASSWORD_MISMATCH;
    }
  }

  /**
   * 生年月日のValidateを行います。
   */
  private validateBirthday() {
    if (StringUtil.isEmpty(this.passwordInfo.birthYear)
      || StringUtil.isEmpty(this.passwordInfo.birthMonth)
      || StringUtil.isEmpty(this.passwordInfo.birthDate)) {
      this.errMsg.birthday = Message.REQUIRED_BIRTHDAY;
    }
  }

  /**
   * 生年月日（年）を設定します。
   * BirthdaySelectのEmitとして呼ばれます。
   *
   * @param year yyyyの文字列
   */
  private setBirthYear(year: string) {
    this.passwordInfo.birthYear = year;
  }

  /**
   * 生年月日（月）を設定します。
   * BirthdaySelectのEmitとして呼ばれます。
   *
   * @param month MMの文字列
   */
  private setBirthMonth(month: string) {
    this.passwordInfo.birthMonth = month;
  }

  /**
   * 生年月日（日）を設定します。
   * BirthdaySelectのEmitとして呼ばれます。
   *
   * @param date ddの文字列
   */
  private setBirthDate(date: string) {
    this.passwordInfo.birthDate = date;
  }
}
